/**
 * Catálogo REAL de sucursales (159 tiendas) usado por el tablero hi-fi.
 * Copiado verbatim desde el design handoff
 * (`tablero/design_handoff_tablero_colectivo_moda/stores.js`).
 *
 * NO editar a mano: si el catálogo cambia, regenerar desde la fuente.
 */

export interface Store {
  id: string;
  cadena: string;
  tienda: string;
  num: string;
  supervisor: string;
  regional: string;
  /**
   * Sólo en una tienda CERRADA (SPEC 2026-10-13, punto b): su última actividad
   * y el día en que salió del catálogo. Cuenta en los periodos en que operó
   * (`utils/catalogoEfectivo.ts`).
   */
  cerrada?: { ultimaActividad: string; cerrada: string };
}

export const STORES: Store[] = [
  {
    "id": "VAZZA#1",
    "cadena": "VAZZA",
    "tienda": "REGINA",
    "num": "1",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#2",
    "cadena": "VAZZA",
    "tienda": "SAN JERONIMO",
    "num": "2",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#4",
    "cadena": "VAZZA",
    "tienda": "PLAZA",
    "num": "4",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#5",
    "cadena": "VAZZA",
    "tienda": "TEXCOCO",
    "num": "5",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#8",
    "cadena": "VAZZA",
    "tienda": "AZCAPOTZALCO",
    "num": "8",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#9",
    "cadena": "VAZZA",
    "tienda": "INSURGENTES",
    "num": "9",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#10",
    "cadena": "VAZZA",
    "tienda": "JUAREZ",
    "num": "10",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#11",
    "cadena": "VAZZA",
    "tienda": "ORIZABA",
    "num": "11",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#12",
    "cadena": "VAZZA",
    "tienda": "SIETE",
    "num": "12",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#13",
    "cadena": "VAZZA",
    "tienda": "UNO",
    "num": "13",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#15",
    "cadena": "VAZZA",
    "tienda": "MADERO",
    "num": "15",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#16",
    "cadena": "VAZZA",
    "tienda": "NIZA",
    "num": "16",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#18",
    "cadena": "VAZZA",
    "tienda": "JARDIN",
    "num": "18",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#21",
    "cadena": "VAZZA",
    "tienda": "ALHAMBRA",
    "num": "21",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#22",
    "cadena": "FLEXI",
    "tienda": "TAF PINO",
    "num": "22",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#23",
    "cadena": "FLEXI",
    "tienda": "TAF CORDOBA",
    "num": "23",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#25",
    "cadena": "FLEXI",
    "tienda": "TAF BOCA",
    "num": "25",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#26",
    "cadena": "FLEXI",
    "tienda": "TAF TEXCOCO",
    "num": "26",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#27",
    "cadena": "FLEXI",
    "tienda": "TAF ORIZABA",
    "num": "27",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#28",
    "cadena": "VAZZA",
    "tienda": "HUERTA",
    "num": "28",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#29",
    "cadena": "VAZZA",
    "tienda": "NAUCALPAN",
    "num": "29",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#31",
    "cadena": "VAZZA",
    "tienda": "TEHUACAN",
    "num": "31",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#32",
    "cadena": "VAZZA",
    "tienda": "ALLENDE",
    "num": "32",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#34",
    "cadena": "VAZZA",
    "tienda": "PARQUE",
    "num": "34",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#35",
    "cadena": "FLEXI",
    "tienda": "TAF MEZONES",
    "num": "35",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#36",
    "cadena": "VAZZA",
    "tienda": "VILLAHERMOSA",
    "num": "36",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#37",
    "cadena": "FLEXI",
    "tienda": "TAF PLAZA VALLE",
    "num": "37",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#38",
    "cadena": "VAZZA",
    "tienda": "ROBLE",
    "num": "38",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#39",
    "cadena": "FLEXI",
    "tienda": "TAF TUXTEPEC",
    "num": "39",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#42",
    "cadena": "VAZZA",
    "tienda": "CARRANZA",
    "num": "42",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#43",
    "cadena": "VAZZA",
    "tienda": "XICO",
    "num": "43",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#44",
    "cadena": "FLEXI",
    "tienda": "TAF SAN MIGUEL",
    "num": "44",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#45",
    "cadena": "VAZZA",
    "tienda": "COSME",
    "num": "45",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#46",
    "cadena": "FLEXI",
    "tienda": "TAF TLALNEPANTLA",
    "num": "46",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#48",
    "cadena": "VAZZA",
    "tienda": "CUATRO",
    "num": "48",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#49",
    "cadena": "VAZZA",
    "tienda": "DUC",
    "num": "49",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#51",
    "cadena": "VAZZA",
    "tienda": "NUEVE",
    "num": "51",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#52",
    "cadena": "VAZZA",
    "tienda": "PLAZA ARAGON",
    "num": "52",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#53",
    "cadena": "FLEXI",
    "tienda": "TAF PATIO TEXCOCO",
    "num": "53",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#54",
    "cadena": "VAZZA",
    "tienda": "ARSABE",
    "num": "54",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#55",
    "cadena": "VAZZA",
    "tienda": "SAN ANGEL",
    "num": "55",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#56",
    "cadena": "VAZZA",
    "tienda": "XOCHIMILCO",
    "num": "56",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#57",
    "cadena": "VAZZA",
    "tienda": "CHALCO",
    "num": "57",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#58",
    "cadena": "VAZZA",
    "tienda": "CUAJIMALPA",
    "num": "58",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#59",
    "cadena": "MARCHA",
    "tienda": "MIXCOAC",
    "num": "59",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#61",
    "cadena": "FLEXI",
    "tienda": "TAF TEHUACAN",
    "num": "61",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#62",
    "cadena": "FLEXI",
    "tienda": "TAF 5 DE FEBRERO",
    "num": "62",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#63",
    "cadena": "VAZZA",
    "tienda": "ZLOP",
    "num": "63",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#64",
    "cadena": "VAZZA",
    "tienda": "FERRE",
    "num": "64",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#68",
    "cadena": "VAZZA",
    "tienda": "PUEBLA",
    "num": "68",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#90",
    "cadena": "VAZZA",
    "tienda": "CUERNAVACA",
    "num": "90",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#101",
    "cadena": "FLEXI",
    "tienda": "TAF COATZACOALCOS",
    "num": "101",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#103",
    "cadena": "VAZZA",
    "tienda": "COLON",
    "num": "103",
    "supervisor": "TERESA LOBATO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#104",
    "cadena": "VAZZA",
    "tienda": "TLANE",
    "num": "104",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#106",
    "cadena": "VAZZA",
    "tienda": "CRYSTAL",
    "num": "106",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#109",
    "cadena": "VAZZA",
    "tienda": "XALAPA",
    "num": "109",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#111",
    "cadena": "FLEXI",
    "tienda": "TAF XICO",
    "num": "111",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#113",
    "cadena": "VAZZA",
    "tienda": "LUCIO",
    "num": "113",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#114",
    "cadena": "VAZZA",
    "tienda": "TACUBAYA",
    "num": "114",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#116",
    "cadena": "VAZZA",
    "tienda": "BOCA",
    "num": "116",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#118",
    "cadena": "FLEXI",
    "tienda": "TAF ANTENAS",
    "num": "118",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#120",
    "cadena": "FLEXI",
    "tienda": "TAF MADERO",
    "num": "120",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#131",
    "cadena": "MARCHA",
    "tienda": "MARCHA PINO",
    "num": "131",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#132",
    "cadena": "VAZZA",
    "tienda": "DEL PARQUE",
    "num": "132",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#138",
    "cadena": "MARCHA",
    "tienda": "MARCHA XALAPA",
    "num": "138",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#139",
    "cadena": "VAZZA",
    "tienda": "TECAMAC",
    "num": "139",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#142",
    "cadena": "MARCHA",
    "tienda": "MARCHA TOREO",
    "num": "142",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#143",
    "cadena": "MARCHA",
    "tienda": "MR ANTENAS",
    "num": "143",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#144",
    "cadena": "VAZZA",
    "tienda": "CUAUTITLÁN",
    "num": "144",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#147",
    "cadena": "VAZZA",
    "tienda": "Latino",
    "num": "147",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#148",
    "cadena": "FLEXI",
    "tienda": "TAF LAZARO CARDENAS",
    "num": "148",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#149",
    "cadena": "MARCHA",
    "tienda": "MR SAN ANGEL",
    "num": "149",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#153",
    "cadena": "MARCHA",
    "tienda": "MR XOCHIMILCO",
    "num": "153",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#154",
    "cadena": "FLEXI",
    "tienda": "TAF TOREO",
    "num": "154",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#155",
    "cadena": "FLEXI",
    "tienda": "TAF SAN COSME",
    "num": "155",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#156",
    "cadena": "VAZZA",
    "tienda": "GUSTAVO BAZ",
    "num": "156",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#157",
    "cadena": "VAZZA",
    "tienda": "ARCOS",
    "num": "157",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#159",
    "cadena": "VAZZA",
    "tienda": "GALEANA",
    "num": "159",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#160",
    "cadena": "VAZZA",
    "tienda": "IXTAPALUCA",
    "num": "160",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#180",
    "cadena": "VAZZA",
    "tienda": "COTILLA",
    "num": "180",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#181",
    "cadena": "MARCHA",
    "tienda": "MR IXTAPALUCA",
    "num": "181",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#184",
    "cadena": "VAZZA",
    "tienda": "MORELIA",
    "num": "184",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#185",
    "cadena": "VAZZA",
    "tienda": "VALLADOLID",
    "num": "185",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#186",
    "cadena": "FLEXI",
    "tienda": "OUTLET TACUBAYA",
    "num": "186",
    "supervisor": "ESTHER MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#188",
    "cadena": "FLEXI",
    "tienda": "TAF URUGUAY",
    "num": "188",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#189",
    "cadena": "VAZZA",
    "tienda": "SAN LUIS",
    "num": "189",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#190",
    "cadena": "VAZZA",
    "tienda": "OCAMPO",
    "num": "190",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#191",
    "cadena": "VAZZA",
    "tienda": "CUAUTLA",
    "num": "191",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#192",
    "cadena": "VAZZA",
    "tienda": "GUERRERO",
    "num": "192",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#193",
    "cadena": "VAZZA",
    "tienda": "URUAPAN",
    "num": "193",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#194",
    "cadena": "VAZZA",
    "tienda": "ZITACUARO",
    "num": "194",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#195",
    "cadena": "VAZZA",
    "tienda": "PORTAL ALDAMA",
    "num": "195",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#197",
    "cadena": "VAZZA",
    "tienda": "DORADA",
    "num": "197",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#198",
    "cadena": "VAZZA",
    "tienda": "PACHUCA",
    "num": "198",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#199",
    "cadena": "VAZZA",
    "tienda": "IGUALA",
    "num": "199",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#200",
    "cadena": "VAZZA",
    "tienda": "CUPATITZIO",
    "num": "200",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#201",
    "cadena": "FLEXI",
    "tienda": "TAF IGUALA",
    "num": "201",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#202",
    "cadena": "VAZZA",
    "tienda": "ZUMPANGO",
    "num": "202",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#205",
    "cadena": "MARCHA",
    "tienda": "MR ARAGON",
    "num": "205",
    "supervisor": "MARICELA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#206",
    "cadena": "MARCHA",
    "tienda": "MR SAN LUIS",
    "num": "206",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#207",
    "cadena": "MARCHA",
    "tienda": "MR SAN COSME",
    "num": "207",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#210",
    "cadena": "FLEXI",
    "tienda": "TAF ZITACUARO",
    "num": "210",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#213",
    "cadena": "VAZZA",
    "tienda": "URUAPAN PORTALES",
    "num": "213",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#215",
    "cadena": "MARCHA",
    "tienda": "MR QUERETARO",
    "num": "215",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#219",
    "cadena": "VAZZA",
    "tienda": "ARTEAGA",
    "num": "219",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#220",
    "cadena": "VAZZA",
    "tienda": "COSMOPOL",
    "num": "220",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#221",
    "cadena": "VAZZA",
    "tienda": "MORELOS",
    "num": "221",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#222",
    "cadena": "MARCHA",
    "tienda": "MR TECAMAC",
    "num": "222",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#223",
    "cadena": "MARCHA",
    "tienda": "MR AZCAPO",
    "num": "223",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#224",
    "cadena": "VAZZA",
    "tienda": "PUERTA TEXCOCO",
    "num": "224",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#226",
    "cadena": "FLEXI",
    "tienda": "TAF REYNOSA",
    "num": "226",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "FLEXI#227",
    "cadena": "FLEXI",
    "tienda": "TAF CUERNAVACA",
    "num": "227",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "MARCHA#230",
    "cadena": "MARCHA",
    "tienda": "MR SEND SAN LUIS",
    "num": "230",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#231",
    "cadena": "FLEXI",
    "tienda": "SANTO DOMINGO",
    "num": "231",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#233",
    "cadena": "VAZZA",
    "tienda": "TAMPICO",
    "num": "233",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#234",
    "cadena": "MARCHA",
    "tienda": "MR ADUANA",
    "num": "234",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#235",
    "cadena": "VAZZA",
    "tienda": "DIAZ MIRON",
    "num": "235",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#236",
    "cadena": "VAZZA",
    "tienda": "NORTE",
    "num": "236",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#237",
    "cadena": "VAZZA",
    "tienda": "TRES ARCOS",
    "num": "237",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#238",
    "cadena": "VAZZA",
    "tienda": "AMPLIACION",
    "num": "238",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "VAZZA#239",
    "cadena": "VAZZA",
    "tienda": "EJERCITO",
    "num": "239",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#240",
    "cadena": "FLEXI",
    "tienda": "TAF CARRANZA",
    "num": "240",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#241",
    "cadena": "FLEXI",
    "tienda": "TAF OUTLET",
    "num": "241",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#242",
    "cadena": "FLEXI",
    "tienda": "TAF ALTAMA",
    "num": "242",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "FLEXI#243",
    "cadena": "FLEXI",
    "tienda": "TAF NORTE",
    "num": "243",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#244",
    "cadena": "TRENDER",
    "tienda": "ALTAMA",
    "num": "244",
    "supervisor": "MARIA ZAMORA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#70",
    "cadena": "TRENDER",
    "tienda": "PUNTA NORTE",
    "num": "70",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#71",
    "cadena": "TRENDER",
    "tienda": "BICENTENARIO",
    "num": "71",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#74",
    "cadena": "TRENDER",
    "tienda": "TEZONTLE",
    "num": "74",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#76",
    "cadena": "TRENDER",
    "tienda": "SANTA FE",
    "num": "76",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#77",
    "cadena": "TRENDER",
    "tienda": "COAPA",
    "num": "77",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#79",
    "cadena": "TRENDER",
    "tienda": "MULTIPLAZA",
    "num": "79",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#87",
    "cadena": "TRENDER",
    "tienda": "VIA VALLEJO",
    "num": "87",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#89",
    "cadena": "TRENDER",
    "tienda": "DELTA",
    "num": "89",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#108",
    "cadena": "TRENDER",
    "tienda": "TR MADERO",
    "num": "108",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#112",
    "cadena": "TRENDER",
    "tienda": "MULZA",
    "num": "112",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#115",
    "cadena": "TRENDER",
    "tienda": "TR PUEBLA",
    "num": "115",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#118",
    "cadena": "TRENDER",
    "tienda": "TR ANTENAS",
    "num": "118",
    "supervisor": "JOSEFA RAMIREZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#121",
    "cadena": "TRENDER",
    "tienda": "TR METEPEC",
    "num": "121",
    "supervisor": "GABRIEL GARCIA",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#123",
    "cadena": "TRENDER",
    "tienda": "ANGELOPOLIS",
    "num": "123",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#150",
    "cadena": "TRENDER",
    "tienda": "BOCA",
    "num": "150",
    "supervisor": "DAVID DE LA CRUZ",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#151",
    "cadena": "TRENDER",
    "tienda": "PATRIA",
    "num": "151",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#152",
    "cadena": "TRENDER",
    "tienda": "PLAZA DEL SOL",
    "num": "152",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#162",
    "cadena": "TRENDER",
    "tienda": "ALTARIA",
    "num": "162",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#163",
    "cadena": "TRENDER",
    "tienda": "ARENA",
    "num": "163",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#164",
    "cadena": "TRENDER",
    "tienda": "CANCUN",
    "num": "164",
    "supervisor": "BELEN LOPEZ",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#165",
    "cadena": "TRENDER",
    "tienda": "AMERICAS",
    "num": "165",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#167",
    "cadena": "TRENDER",
    "tienda": "SATELITE",
    "num": "167",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#170",
    "cadena": "TRENDER",
    "tienda": "TOROS",
    "num": "170",
    "supervisor": "MEZTLI MORALES",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#171",
    "cadena": "TRENDER",
    "tienda": "GUADALAJARA",
    "num": "171",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#172",
    "cadena": "TRENDER",
    "tienda": "TLAQUEPAQUE",
    "num": "172",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#173",
    "cadena": "TRENDER",
    "tienda": "GRAN PLAZA",
    "num": "173",
    "supervisor": "GERMAN TINOCO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "TRENDER#177",
    "cadena": "TRENDER",
    "tienda": "PARQUE TEPEYAC",
    "num": "177",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#183",
    "cadena": "TRENDER",
    "tienda": "OUTLET PUEBLA",
    "num": "183",
    "supervisor": "RUTH TORRES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#225",
    "cadena": "TRENDER",
    "tienda": "LINDAVISTA",
    "num": "225",
    "supervisor": "LORENA CARRILLO",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "TRENDER#232",
    "cadena": "TRENDER",
    "tienda": "PUERTA VICTORIA",
    "num": "232",
    "supervisor": "SANDRA RAYO",
    "regional": "Arturo Barrios"
  },
  {
    "id": "MARCHA#248",
    "cadena": "MARCHA",
    "tienda": "MR PATIO TEXCOCO",
    "num": "248",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  },
  {
    "id": "VAZZA#247",
    "cadena": "VAZZA",
    "tienda": "PATIO TEXCOCO",
    "num": "247",
    "supervisor": "ALICIA MORALES",
    "regional": "Jorge Ramiro"
  }
];

/**
 * Cadena interna (Proscai/CATPAR6) que corresponde a cada `cadena` del
 * catálogo de tiendas. El catálogo usa los nombres comerciales completos
 * (VAZZA, FLEXI, MARCHA, TRENDER); el backend usa los códigos cortos.
 */
export type Chain = 'VAZ' | 'TAF' | 'MRH' | 'TRE';

const CADENA_TO_CHAIN: Record<string, Chain> = {
  VAZZA: 'VAZ',
  FLEXI: 'TAF',
  MARCHA: 'MRH',
  TRENDER: 'TRE',
};

/**
 * Convierte el nombre comercial de cadena del catálogo (`store.cadena`,
 * ej. "VAZZA") al código corto que espera el backend (ej. "VAZ").
 * Lanza si la cadena no está en el mapa (catálogo corrupto/desactualizado).
 */
export function cadenaToChain(cadena: string): Chain {
  const chain = CADENA_TO_CHAIN[cadena];
  if (!chain) {
    throw new Error(`cadenaToChain: cadena desconocida "${cadena}"`);
  }
  return chain;
}

/**
 * Deriva `{chain, branchOffice}` (los parámetros que esperan los endpoints
 * de `/dashboard`) a partir de una `Store` del catálogo.
 */
export function storeChainBranch(s: Store): { chain: Chain; branchOffice: number } {
  return {
    chain: cadenaToChain(s.cadena),
    branchOffice: Number(s.num),
  };
}
